import type {
  StellarAction,
  StellarActionResponse,
  StellarBootstrapResponse,
  StellarSummary,
} from "../shared/stellar-types";
import { apiRequest } from "./client";

export function getStellarSummary() {
  return apiRequest<StellarSummary>("/api/stellar/summary");
}

export function bootstrapStellar(csrfToken: string, idempotencyKey: string) {
  return apiRequest<StellarBootstrapResponse>("/api/stellar/bootstrap", {
    method: "POST",
    csrfToken,
    idempotencyKey,
    keepalive: true,
  });
}

export function submitStellarAction(
  action: StellarAction,
  csrfToken: string,
  idempotencyKey: string,
) {
  return apiRequest<StellarActionResponse>("/api/stellar/action", {
    method: "POST",
    body: action,
    csrfToken,
    idempotencyKey,
    keepalive: true,
  });
}

export function deleteStellarProgress(csrfToken: string) {
  return apiRequest<{ deleted: true }>("/api/stellar", {
    method: "DELETE",
    csrfToken,
  });
}
